// Interesting take on isolated vs redux components: https://medium.com/netscape/component-state-vs-redux-store-1eb0c929277
// Slow rendering: https://github.com/amcharts/amcharts4/issues/723
import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';
import am4themesAnimated from '@amcharts/amcharts4/themes/animated';
import _ from 'lodash';

import { COLORS, DIMENSIONS, FONT_SIZES, CN_FONT_SIZES } from '../../../styles/constants';
import filterbarSlice from '../../Filterbar/filterbarSlice';
import { CALC_RESULT_CHART } from '../../Charts/constants';
import { getDomain } from '../../../utils/config';

const FONT_SIZE = getDomain() === 'onsemi.com' ? FONT_SIZES : CN_FONT_SIZES;

class ColumnAmChart extends Component {
	componentDidMount() {
		this.initChart();
	}

	constructor() {
		super();
		this.chartId = 'designs-distribution-chart';
	}

	componentDidUpdate(prevProps) {
		// Handle refreshing the chart when the dataset changes
		if (!_.isEqual(prevProps.data, this.props.data)) {
			if (this.chart) {
				this.chart.dispose();
			}

			this.initChart();
		}
	}

	componentWillUnmount() {
		if (this.chart) {
			this.chart.dispose();
		}
	}

	initChart() {
		const { attribute, data, changeRangeFilterValues, rangeFiltersMinMax, clearFilters } = this.props;

		am4core.useTheme(am4themesAnimated);
		am4core.options.commercialLicense = true;
		am4core.addLicense('CH2281-6107-0011-9579');

		this.chart = am4core.create(this.chartId, am4charts.XYChart);
		this.chart.data = data;
		this.chart.colors.list = [am4core.color('#b8b8b8')];

		const xAxis = this.chart.xAxes.push(new am4charts.CategoryAxis());
		xAxis.dataFields.category = 'interval';
		xAxis.renderer.grid.template.disabled = true;
		xAxis.renderer.labels.template.disabled = true;

		const yAxis = this.chart.yAxes.push(new am4charts.ValueAxis());
		yAxis.renderer.labels.template.fontSize = FONT_SIZE.BODY2;
		yAxis.renderer.labels.template.fill = am4core.color('rgb(155,155,155)');
		yAxis.title.html = CALC_RESULT_CHART.yAxis;
		yAxis.title.fontSize = FONT_SIZE.BODY2;
		yAxis.title.fill = am4core.color('rgb(155,155,155)');
		// YAxis.title.marginRight = 8;
		// yAxis.renderer.grid.template.disabled = true;
		// yAxis.renderer.labels.template.disabled = true;

		const series = this.chart.series.push(new am4charts.ColumnSeries());
		series.dataFields.valueY = 'designCount';
		series.dataFields.categoryX = 'interval';
		series.name = 'Designs';
		series.columns.template.cursorOverStyle = am4core.MouseCursorStyle.pointer;

		series.tooltip.pointerOrientation = 'down';
		series.columns.template.tooltipY = 0;
		series.columns.template.tooltipText =
			'[font-size: 13px;]' +
			attribute.label +
			': [font-size: 13px; bold]{categoryX}' +
			' [' +
			attribute.unit +
			']\n [/][font-size: 13px;]' +
			CALC_RESULT_CHART.yAxis +
			': [font-size: 13px; bold]{valueY}[/]';
		series.tooltip.getFillFromObject = false;
		series.tooltip.background.fill = am4core.color(COLORS.SECONDARY);
		series.tooltip.background.cornerRadius = 4;
		series.tooltip.background.strokeOpacity = 0;
		series.tooltip.dy = -3;

		series.columns.template.width = am4core.percent(90);
		series.columns.template.stroke = am4core.color(COLORS.SECONDARY);
		series.columns.template.fill = am4core.color(COLORS.SECONDARY);
		series.columns.template.fillOpacity = 0.9;
		series.columns.template.column.cornerRadiusTopLeft = 0.4;
		series.columns.template.column.cornerRadiusTopRight = 0.4;

		series.columns.template.events.on(
			'hit',
			ev => {
				clearFilters(rangeFiltersMinMax);

				changeRangeFilterValues({
					filter: attribute.name,
					values: Array.from(ev.target._dataItem.categories.categoryX.split(' - ')).map(item => Number(item))
				});
			},
			this
		);

		const hoverState = series.columns.template.states.create('hover');
		hoverState.properties.stroke = am4core.color(COLORS.PRIMARY);
		hoverState.properties.fill = am4core.color(COLORS.PRIMARY);
		hoverState.properties.fillOpacity = 1;
	}

	render() {
		return (
			<div
				id={this.chartId}
				style={{
					width: '100%',
					height: DIMENSIONS.DISTRIBUTION_CHART_HEIGHT,
					fontFamily: 'Inter'
				}}
			/>
		);
	}
}

ColumnAmChart.propTypes = {
	attribute: PropTypes.object.isRequired,
	data: PropTypes.arrayOf(PropTypes.object).isRequired,
	changeRangeFilterValues: PropTypes.func
};

const mapDispatchToProps = dispatch => ({
	changeRangeFilterValues: filterValues => dispatch(filterbarSlice.actions.changeRangeFilterValues(filterValues)),
	clearFilters: filters => dispatch(filterbarSlice.actions.clearFilters(filters))
});

export default connect(null, mapDispatchToProps)(ColumnAmChart);
